import React from 'react';

const ScoreSection = ({ children }) => (
  <div className="inside-score-table-wr">
    { children }
  </div>
);

export default ScoreSection;
